import { useDispatch } from "react-redux";

import Tiles from "../Tiles/Tiles";
import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";

import { Club } from "../../store/Session/SessionModel";
import sessionSlice from "../../store/Session/SessionSlice";

import "./style.css";
import ToggleClub from "../ToggleClub/ToggleClub";

interface Props {
  club: Club;
  tabSelected: "ball-data" | "club-data" | "key-data";
}

const ModuleKeyData = ({ club, tabSelected }: Props): JSX.Element => {
  const dispatch = useDispatch();

  const setIsShowShots = (isShowShots: boolean) => {
    if (club.isActive) {
      dispatch(
        sessionSlice.actions.setIsShowShots({
          isShowShots,
          clubId: club.clubId
        })
      );
    }
  };

  return (
    <div
      className={`club module-key-data module-key-data-instance-inactive-${!club.isActive}`}
    >
      <div className="frame">
        <div className="club">
          <ToggleClub club={club} />
          <div className="club-name">
            <SkeletonLineWrapper>{club.clubName}</SkeletonLineWrapper>
          </div>
        </div>

        <div className="club-nickname">
          <SkeletonLineWrapper>{club.clubNickname}</SkeletonLineWrapper>
        </div>
        <div className="frame-shots">
          <div
            className="shot-count"
            onClick={() => setIsShowShots(!club.isShowShots)}
          >
            <img
              className="arrow"
              alt=""
              src={
                club.isShowShots
                  ? "/img/fs_arrow-down.svg"
                  : "/img/fs_arrow.svg"
              }
            />
            <div className="shot-count-text">
              <SkeletonLineWrapper>{`${club.totalShots} Shots`}</SkeletonLineWrapper>
            </div>
          </div>
          <div className="avg-text">AVG</div>
          <div className="avg-shot-count-text">
            <SkeletonLineWrapper>{`${club.totalShots} Shots`}</SkeletonLineWrapper>
          </div>
        </div>
      </div>
      <Tiles tabSelected={tabSelected} club={club} />
    </div>
  );
};

export default ModuleKeyData;
